import {
  Spin,
  Form,
  Row,
  Col,
  message,
  Divider,
  Input,
  Select,
  Alert,
  Descriptions,
  Card,
  Switch,
  Modal,
} from "antd";
import { LockOutlined, PlusOutlined, MinusOutlined,  } from "@ant-design/icons";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  FormItem,
  ErrorItem,
  ButtonItem,
  SelectItem,
  InputItem,
  InputNumberItem,
} from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import axios from "axios";

const { Option } = Select;

class EnviosConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    formConCambios: false,
    envioManualActivo: false,
    // Ubicación bodega
    todasPaises: [],
    todasEstados: [],
    objetoMunicipiosBodega: null,
    objetoColoniasBodega: null,
    todasColoniasBodega: null,
    // Ubicación sucursales
    objetoMunicipiosSucursales: {},
    objetoColoniasSucursales: {},
    todasColoniasSucursales: {},
    // Paqueterías y dropshipping
    catalogoPaqueterias: [],
    proveedoresDropshipping: [],
    proveedorUrreaSeleccionado: null,
    // Escuelas
    escuelas: [],
    escuelaSeleccionadaId: null,
    configEscuelaExiste: false,
    configEscuelaActiva: false,
    loadingEscuela: false,
    previewSucursal: null,
  };

  componentDidMount() {
    this.cargarConfigEmpresa();
    this.cargarDatosUbicacionIniciales();
    this.cargarCatalogoPaqueterias();
    this.buscarProveedoresDropshipping("");
    if (this.props.escuela) {
      this.cargarEscuelas();
    }
  }

  cargarConfigEmpresa = () => {
    this.setState({ loading: true });
    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionApis",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.data) {
          this._aplicarConfigAlForm(res.data.data);
        }
      })
      .catch(() => message.error("Error al cargar la configuración de envíos"))
      .finally(() => this.setState({ loading: false, formConCambios: false }));
  };

  cargarConfigEscuela = (escuelaId) => {
    this.setState({ loadingEscuela: true });
    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionEnvioEscuela",
        { empresaId: this.props.empresaId, escuelaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (res.data.data) {
            this._aplicarConfigAlForm(res.data.data);
            this.setState({ configEscuelaExiste: true, configEscuelaActiva: !!res.data.data.activo });
          } else {
            this.setState({ configEscuelaExiste: false, configEscuelaActiva: false, formConCambios: false });
          }
        }
      })
      .catch(() => message.error("Error al cargar la configuración de la escuela"))
      .finally(() => this.setState({ loadingEscuela: false }));
  };

  _aplicarConfigAlForm = (config) => {
    this.setState({ envioManualActivo: !!config.envioManual?.activo });

    if (config.logistica?.proveedorDropshippingId) {
      this.obtenerDatosProveedorUnico(config.logistica.proveedorDropshippingId);
    }

    if (config.envia?.direccionBodega?.estadoId) {
      this.onChangeEstadoBodega(config.envia.direccionBodega.estadoId, true);
    }
    if (config.envia?.direccionBodega?.municipioId) {
      this.onChangeMunicipioBodega(config.envia.direccionBodega.municipioId, true);
    }

    const direccionesSucursal = config.envia?.entregaSucursal?.direcciones || [];
    direccionesSucursal.forEach((dir, index) => {
      if (dir?.estadoId) this.onChangeEstadoSucursal(index, dir.estadoId, true);
      if (dir?.municipioId) this.onChangeMunicipioSucursal(index, dir.municipioId, true);
    });

    this.formRef.current?.setFieldsValue({
      logistica: {
        proveedorDropshippingId: config.logistica?.proveedorDropshippingId || undefined,
      },
      envia: {
        token: config.envia?.token || "",
        paqueteriasActivas: config.envia?.paqueteriasActivas || [],
        direccionBodega: config.envia?.direccionBodega || {},
        reglasPrecios: config.envia?.reglasPrecios || {
          montoParaEnvioGratis: 0,
          modoCobro: "exacto",
          porcentajeExtra: 0,
          rangos: [],
        },
        entregaSucursal: {
          activada: !!config.envia?.entregaSucursal?.activada,
          etiquetaMetodo: config.envia?.entregaSucursal?.etiquetaMetodo || "",
          tituloSeccion: config.envia?.entregaSucursal?.tituloSeccion || "",
          descripcionCheckout: config.envia?.entregaSucursal?.descripcionCheckout || "",
          direcciones: config.envia?.entregaSucursal?.direcciones || [],
        },
        desactivarEnvioDomicilio: !!config.envia?.desactivarEnvioDomicilio,
      },
      envioManual: {
        activo: !!config.envioManual?.activo,
        leyenda: config.envioManual?.leyenda || "",
        descripcionCliente: config.envioManual?.descripcionCliente || "",
        costoFijo: config.envioManual?.costoFijo || 0,
        montoParaEnvioGratis: config.envioManual?.montoParaEnvioGratis || 0,
      },
    });
    this.setState({ previewSucursal: config.envia?.entregaSucursal || null });
  };

  cargarEscuelas = () => {
    axios
      .post(
        "escuelas/selectTodasEscuelas",
        { empresaId: this.props.empresaId, valor: 1, pageSize: 1000 },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ escuelas: res.data.data || [] });
        }
      })
      .catch(() => {});
  };

  onSelectEscuela = (nuevaEscuelaId) => {
    if (this.state.formConCambios) {
      Modal.confirm({
        title: "Tienes cambios sin guardar",
        content: "¿Descartar los cambios y cambiar de escuela?",
        okText: "Descartar y cambiar",
        cancelText: "Cancelar",
        centered: true,
        onOk: () => {
          this._cambiarEscuela(nuevaEscuelaId);
        },
      });
    } else {
      this._cambiarEscuela(nuevaEscuelaId);
    }
  };

  _cambiarEscuela = (escuelaId) => {
    this.setState({ escuelaSeleccionadaId: escuelaId, configEscuelaExiste: false, configEscuelaActiva: false, formConCambios: false });
    this.cargarConfigEscuela(escuelaId);
  };

  onDeseleccionarEscuela = () => {
    if (this.state.formConCambios) {
      Modal.confirm({
        title: "Tienes cambios sin guardar",
        content: "¿Descartar los cambios y volver a la configuración general?",
        okText: "Descartar y volver",
        cancelText: "Cancelar",
        centered: true,
        onOk: () => this._volverAEmpresa(),
      });
    } else {
      this._volverAEmpresa();
    }
  };

  _volverAEmpresa = () => {
    this.setState({ escuelaSeleccionadaId: null, configEscuelaExiste: false, configEscuelaActiva: false, formConCambios: false });
    this.cargarConfigEmpresa();
  };

  desactivarConfigEscuela = () => {
    Modal.confirm({
      title: "¿Usar configuración general?",
      content: "La escuela pasará a usar la configuración general de la empresa. La configuración propia se conserva y podrás volver a activarla cuando quieras.",
      okText: "Usar config general",
      okButtonProps: { danger: true },
      cancelText: "Cancelar",
      centered: true,
      onOk: () => {
        this.setState({ loadingEscuela: true });
        axios
          .post(
            "configuracionTiendaOnline/actualizarConfiguracionEnvioEscuela",
            { empresaId: this.props.empresaId, escuelaId: this.state.escuelaSeleccionadaId, activo: false },
            { headers: this.props.headersToken },
          )
          .then((res) => {
            if (res.data.success === 2) {
              message.success("Escuela usando configuración general de la empresa");
              this.setState({ configEscuelaActiva: false });
            }
          })
          .catch(() => message.error("Error al actualizar la configuración"))
          .finally(() => this.setState({ loadingEscuela: false }));
      },
    });
  };

  activarConfigEscuela = () => {
    this.setState({ loadingEscuela: true });
    axios
      .post(
        "configuracionTiendaOnline/actualizarConfiguracionEnvioEscuela",
        { empresaId: this.props.empresaId, escuelaId: this.state.escuelaSeleccionadaId, activo: true },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Configuración propia de la escuela activada");
          this.setState({ configEscuelaActiva: true });
        }
      })
      .catch(() => message.error("Error al activar la configuración"))
      .finally(() => this.setState({ loadingEscuela: false }));
  };

  onFinish = async (values) => {
    this.setState({ loading: true });

    if (!this.props.permisoAnadirModificarTokens && values.envia) {
      delete values.envia.token;
    }

    const { escuelaSeleccionadaId } = this.state;

    if (escuelaSeleccionadaId) {
      return axios
        .post(
          "configuracionTiendaOnline/actualizarConfiguracionEnvioEscuela",
          { empresaId: this.props.empresaId, escuelaId: escuelaSeleccionadaId, activo: true, ...values },
          { headers: this.props.headersToken },
        )
        .then((res) => {
          if (res.data.success === 2) {
            message.success("Configuración de envío de escuela guardada");
            this.setState({ formConCambios: false, configEscuelaExiste: true, configEscuelaActiva: true });
            return true;
          }
          message.error("No se pudo guardar la configuración");
          return false;
        })
        .catch(() => { message.error("Error al guardar"); return false; })
        .finally(() => this.setState({ loading: false }));
    }

    return axios
      .post(
        "configuracionTiendaOnline/actualizarConfiguracionApis",
        { empresaId: this.props.empresaId, ...values },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuración de envíos");
          this.setState({ formConCambios: false });
          return true;
        }
        message.error("No se pudo modificar la configuración");
        return false;
      })
      .catch(() => { message.error("Error al guardar"); return false; })
      .finally(() => this.setState({ loading: false }));
  };

  onFinishFailed = (e) => ErrorItem(e);

  tieneCambios = () => this.state.formConCambios;

  guardarDesdePadre = () =>
    this.formRef.current
      .validateFields()
      .then((values) => this.onFinish(values))
      .catch((info) => { console.log("Validate Failed:", info); return false; });

  descartarCambios = () => {
    this.setState({ formConCambios: false });
    if (this.state.escuelaSeleccionadaId) {
      this.cargarConfigEscuela(this.state.escuelaSeleccionadaId);
    } else {
      this.cargarConfigEmpresa();
    }
  };

  handleValuesChange = (changedValues) => {
    if (!this.state.formConCambios) this.setState({ formConCambios: true });

    if (changedValues?.envioManual?.activo !== undefined) {
      this.setState({ envioManualActivo: !!changedValues.envioManual.activo });
    }

    if (changedValues?.envia?.reglasPrecios?.rangos) {
      const allValues = this.formRef.current.getFieldsValue(true);
      const rangos = allValues.envia?.reglasPrecios?.rangos || [];
      let necesitaAjuste = false;
      const rangosCalculados = rangos.map((rango, index) => {
        const minEsperado = index === 0 ? 0 : (Number(rangos[index - 1]?.costoApiMaximo) || 0) + 0.01;
        const minFixed = Number(minEsperado.toFixed(2));
        if (rango?.costoApiMinimo !== minFixed) {
          necesitaAjuste = true;
          return { ...rango, costoApiMinimo: minFixed };
        }
        return rango;
      });
      if (necesitaAjuste) {
        setTimeout(() => {
          this.formRef.current.setFieldsValue({
            envia: { ...allValues.envia, reglasPrecios: { ...allValues.envia.reglasPrecios, rangos: rangosCalculados } },
          });
        }, 10);
      }
    }

    const sucursal = this.formRef.current?.getFieldValue(["envia", "entregaSucursal"]);
    if (sucursal !== undefined) this.setState({ previewSucursal: sucursal });

    // No puede quedar sin ningún método de envío: si se desactiva la entrega en
    // sucursal, forzamos a reactivar el envío a domicilio.
    if (changedValues?.envia?.entregaSucursal?.activada === false) {
      const currentEnvia = this.formRef.current.getFieldValue("envia");
      if (currentEnvia?.desactivarEnvioDomicilio) {
        this.formRef.current.setFieldsValue({
          envia: { ...currentEnvia, desactivarEnvioDomicilio: false },
        });
        message.warning(
          "Se reactivó el envío a domicilio: no puede estar desactivado si la entrega en sucursal también lo está.",
        );
      }
    }
  };

  cargarDatosUbicacionIniciales = () => {
    axios
      .post("proveedores/selectDatosParaProveedor", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasPaises: res.data.paises, todasEstados: res.data.estados });
        }
      });
  };

  onChangeEstadoBodega(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        envia: {
          ...this.formRef.current.getFieldValue("envia"),
          direccionBodega: { ...this.formRef.current.getFieldValue(["envia", "direccionBodega"]), municipioId: undefined, coloniaId: undefined },
        },
      });
      this.setState({ objetoMunicipiosBodega: null, objetoColoniasBodega: null });
    }
    axios.post("municipios/selectMunicipios", { estadoId: value }, { headers: this.props.headersToken }).then((res) => {
      this.setState({ objetoMunicipiosBodega: res.data.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>) });
    });
  }

  onChangeMunicipioBodega(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        envia: {
          ...this.formRef.current.getFieldValue("envia"),
          direccionBodega: { ...this.formRef.current.getFieldValue(["envia", "direccionBodega"]), coloniaId: undefined },
        },
      });
      this.setState({ objetoColoniasBodega: null });
    }
    axios.post("colonias/selectColonias", { municipioId: value }, { headers: this.props.headersToken }).then((res) => {
      this.setState({
        todasColoniasBodega: res.data,
        objetoColoniasBodega: res.data.map((v) => <Option value={v._id} key={v._id}>{v.cp + " - " + v.nombre}</Option>),
      });
    });
  }

  onSearchColoniaBodega(value) {
    if (value.toString().length !== 5) return;
    axios.post("colonias/buscarCP", { cp: value }, { headers: this.props.headersToken }).then((res) => {
      if (res.data.status !== 404) {
        const coloniasArr = res.data.colonias || [];
        const objetoColonias = coloniasArr.map((v) => <Option value={v._id} key={v._id}>{v.cp + " - " + v.nombre}</Option>);
        this.setState({ objetoColoniasBodega: objetoColonias, todasColoniasBodega: coloniasArr });
        const currentEnvia = this.formRef.current.getFieldValue("envia");
        const primeraColonia = coloniasArr[0];
        this.formRef.current.setFieldsValue({
          envia: { ...currentEnvia, direccionBodega: { ...currentEnvia.direccionBodega, paisId: res.data.paisId, estadoId: res.data.estadoId, municipioId: res.data.municipioId, coloniaId: primeraColonia?._id, colonia: primeraColonia?.nombre } },
        });
        this.onChangeEstadoBodega(res.data.estadoId, true);
        this.onChangeMunicipioBodega(res.data.municipioId, true);
      }
    });
  }

  onSelectColoniaIdBodega(coloniaId) {
    const nombreColonia = this.state.todasColoniasBodega?.find((c) => c._id.toString() === coloniaId.toString())?.nombre;
    const currentEnvia = this.formRef.current.getFieldValue("envia");
    this.formRef.current.setFieldsValue({ envia: { ...currentEnvia, direccionBodega: { ...currentEnvia.direccionBodega, colonia: nombreColonia } } });
  }

  setDireccionSucursalField = (index, patch) => {
    const direcciones = this.formRef.current.getFieldValue(["envia", "entregaSucursal", "direcciones"]) || [];
    const copia = [...direcciones];
    copia[index] = { ...(copia[index] || {}), ...patch };
    this.formRef.current.setFields([{ name: ["envia", "entregaSucursal", "direcciones"], value: copia }]);
  };

  onChangeEstadoSucursal = (index, value, inicial) => {
    if (!inicial) {
      this.setDireccionSucursalField(index, { estadoId: value, municipioId: undefined, coloniaId: undefined });
      this.setState((prev) => ({
        objetoMunicipiosSucursales: { ...prev.objetoMunicipiosSucursales, [index]: null },
        objetoColoniasSucursales: { ...prev.objetoColoniasSucursales, [index]: null },
      }));
    }
    axios.post("municipios/selectMunicipios", { estadoId: value }, { headers: this.props.headersToken }).then((res) => {
      const options = res.data.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>);
      this.setState((prev) => ({ objetoMunicipiosSucursales: { ...prev.objetoMunicipiosSucursales, [index]: options } }));
    });
  };

  onChangeMunicipioSucursal = (index, value, inicial) => {
    if (!inicial) {
      this.setDireccionSucursalField(index, { coloniaId: undefined });
      this.setState((prev) => ({ objetoColoniasSucursales: { ...prev.objetoColoniasSucursales, [index]: null } }));
    }
    axios.post("colonias/selectColonias", { municipioId: value }, { headers: this.props.headersToken }).then((res) => {
      const options = res.data.map((v) => <Option value={v._id} key={v._id}>{v.cp + " - " + v.nombre}</Option>);
      this.setState((prev) => ({
        todasColoniasSucursales: { ...prev.todasColoniasSucursales, [index]: res.data },
        objetoColoniasSucursales: { ...prev.objetoColoniasSucursales, [index]: options },
      }));
    });
  };

  onSearchColoniaSucursal = (index, value) => {
    if (value.toString().length !== 5) return;
    axios.post("colonias/buscarCP", { cp: value }, { headers: this.props.headersToken }).then((res) => {
      if (res.data.status === 404) return;
      const coloniasArr = res.data.colonias || [];
      const options = coloniasArr.map((v) => <Option value={v._id} key={v._id}>{v.cp + " - " + v.nombre}</Option>);
      this.setState((prev) => ({
        objetoColoniasSucursales: { ...prev.objetoColoniasSucursales, [index]: options },
        todasColoniasSucursales: { ...prev.todasColoniasSucursales, [index]: coloniasArr },
      }));
      const primeraColonia = coloniasArr[0];
      this.setDireccionSucursalField(index, { paisId: res.data.paisId, estadoId: res.data.estadoId, municipioId: res.data.municipioId, coloniaId: primeraColonia?._id, colonia: primeraColonia?.nombre });
      this.onChangeEstadoSucursal(index, res.data.estadoId, true);
      this.onChangeMunicipioSucursal(index, res.data.municipioId, true);
    });
  };

  onSelectColoniaIdSucursal = (index, coloniaId) => {
    const todas = this.state.todasColoniasSucursales[index] || [];
    const nombreColonia = todas.find((c) => c._id.toString() === coloniaId.toString())?.nombre;
    this.setDireccionSucursalField(index, { colonia: nombreColonia });
  };

  buscarProveedoresDropshipping = (busqueda) => {
    axios
      .post("proveedores/obtenerProveedoresDropshipping", { empresaId: this.props.empresaId, busqueda }, { headers: this.props.headersToken })
      .then((res) => { if (res.data.success === 2) this.setState({ proveedoresDropshipping: res.data.data }); });
  };

  obtenerDatosProveedorUnico = (id) => {
    axios
      .post("proveedores/obtenerProveedoresDropshipping", { empresaId: this.props.empresaId, busqueda: "" }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          const proveedor = res.data.data.find((p) => p._id === id);
          if (proveedor) this.setState({ proveedorUrreaSeleccionado: proveedor });
        }
      });
  };

  onSelectProveedorUrrea = (id) => {
    const proveedor = this.state.proveedoresDropshipping.find((p) => p._id === id);
    this.setState({ proveedorUrreaSeleccionado: proveedor });
  };

  cargarCatalogoPaqueterias = () => {
    axios
      .post("configuracionTiendaOnline/obtenerCatalogoPaqueterias", { proveedor: "envia" }, { headers: this.props.headersToken })
      .then((res) => { if (res.data.success === 2) this.setState({ catalogoPaqueterias: res.data.data }); });
  };

  render() {
    const credencialesBloqueadas = !this.props.permisoAnadirModificarTokens;
    const { escuelaSeleccionadaId, configEscuelaExiste, configEscuelaActiva, escuelas, loadingEscuela, envioManualActivo } = this.state;

    const nombreEscuelaActual = escuelas.find((e) => e._id === escuelaSeleccionadaId)?.nombre || "";

    return (
      <Spin spinning={this.state.loading || loadingEscuela}>
        {this.props.escuela && (
          <DynamicCardForm
            title="Configuración por Escuela"
            style={{ marginBottom: 16 }}
          >
            <Alert
              message="¿Cuándo se aplica cada configuración?"
              description="La configuración general aplica a compradores sin sesión iniciada y a alumnos cuya escuela no tenga configuración propia activa. La configuración por escuela solo aplica a alumnos que iniciaron sesión con una escuela asignada."
              type="info"
              showIcon
              style={{ marginBottom: 14 }}
            />
            <Row gutter={8} align="middle">
              <Col flex="auto">
                <SelectItem
                  allowClear
                  placeholder="Selecciona una escuela para configurar su envío"
                  value={escuelaSeleccionadaId}
                  onChange={(val) => {
                    if (!val) {
                      this.onDeseleccionarEscuela();
                    } else {
                      this.onSelectEscuela(val);
                    }
                  }}
                  style={{ width: "100%" }}
                >
                  {escuelas.map((e) => (
                    <Option key={e._id} value={e._id}>{e.nombre}</Option>
                  ))}
                </SelectItem>
              </Col>
              {escuelaSeleccionadaId && configEscuelaExiste && configEscuelaActiva && (
                <Col>
                  <ButtonItem danger onClick={this.desactivarConfigEscuela}>
                    Usar configuración general
                  </ButtonItem>
                </Col>
              )}
              {escuelaSeleccionadaId && configEscuelaExiste && !configEscuelaActiva && (
                <Col>
                  <ButtonItem type="primary" onClick={this.activarConfigEscuela}>
                    Activar configuración propia
                  </ButtonItem>
                </Col>
              )}
            </Row>

            {escuelaSeleccionadaId && !configEscuelaExiste && (
              <Alert
                message={`"${nombreEscuelaActual}" usa la configuración general de la empresa`}
                description="Modifica los campos de envío y guarda para crear una configuración propia para esta escuela."
                type="warning"
                showIcon
                style={{ marginTop: 12 }}
              />
            )}

            {escuelaSeleccionadaId && configEscuelaExiste && configEscuelaActiva && (
              <Alert
                message={`Configuración propia activa para "${nombreEscuelaActual}"`}
                type="success"
                showIcon
                style={{ marginTop: 12 }}
              />
            )}

            {escuelaSeleccionadaId && configEscuelaExiste && !configEscuelaActiva && (
              <Alert
                message={`"${nombreEscuelaActual}" está usando la configuración general`}
                description="La configuración propia está guardada pero inactiva. Pulsa 'Activar configuración propia' para que esta escuela use su config especial."
                type="info"
                showIcon
                style={{ marginTop: 12 }}
              />
            )}
          </DynamicCardForm>
        )}

        <Form
          name="enviosConfiguracion"
          layout="vertical"
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
          onValuesChange={this.handleValuesChange}
          ref={this.formRef}
        >
          {/* ── Row 1: Selección de modo de envío ── */}
          <Row gutter={24}>
            <Col span={12}>
              {/* Envíos Manuales */}
              <DynamicCardForm
                title="Configuración de Envíos Manuales"
                style={{ margin: "0 auto 12px auto", maxWidth: "98%", borderColor: envioManualActivo ? "#52c41a" : undefined }}
              >
                <Alert
                  message="Modo de envío manual / local"
                  description="Activa esta opción si tú te encargas de la logística de tus envíos. Al activarlo se deshabilitarán Envia.com y sus secciones relacionadas (la Entrega en Sucursal seguirá disponible)."
                  type="info"
                  showIcon
                  style={{ marginBottom: 15 }}
                />
                <FormItem label="Activar Envíos Manuales" name={["envioManual", "activo"]} margin valuePropName="checked">
                  <Switch />
                </FormItem>
                {envioManualActivo && (
                  <>
                    <FormItem label="Leyenda interna (solo visible en este panel)" name={["envioManual", "leyenda"]} margin tooltip="Notas para ti o tu equipo. Este texto no se muestra al cliente.">
                      <Input.TextArea rows={2} placeholder="Ej. Recordar avisar al chofer un día antes." />
                    </FormItem>
                    <FormItem label="Descripción visible al cliente" name={["envioManual", "descripcionCliente"]} margin tooltip="Este texto se mostrará en el checkout del cliente como detalle del envío.">
                      <Input.TextArea rows={2} placeholder="Ej. Cubre toda la zona metropolitana de SLP. Entrega al día siguiente." />
                    </FormItem>
                    <Row gutter={8}>
                      <Col span={12}>
                        <FormItem label="Costo fijo del envío ($)" name={["envioManual", "costoFijo"]} margin tooltip="Monto que se cobrará al cliente por envío en el checkout.">
                          <InputNumberItem placeholder="Ej. 80" style={{ width: "100%" }} min={0} />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem label="Envío gratis a partir de ($)" name={["envioManual", "montoParaEnvioGratis"]} margin tooltip="Si el subtotal supera este monto, el envío será gratis. (0 para desactivar)">
                          <InputNumberItem placeholder="Ej. 1500" style={{ width: "100%" }} min={0} />
                        </FormItem>
                      </Col>
                    </Row>
                  </>
                )}
              </DynamicCardForm>
            </Col>

            <Col span={12}>
              {/* Entrega en Sucursal */}
              <DynamicCardForm title="Entrega en Sucursal" collapsable defaultOpen={false} style={{ margin: "0 auto 12px auto", maxWidth: "98%" }}>
                <Alert message="Puntos de recogida" description="Define hasta 3 sucursales donde el cliente podrá recoger su pedido como alternativa al envío con paquetería." type="info" showIcon style={{ marginBottom: 15 }} />
                <FormItem label="Permitir entrega en sucursal en la tienda online" name={["envia", "entregaSucursal", "activada"]} margin valuePropName="checked">
                  <Switch />
                </FormItem>
                <Form.Item noStyle shouldUpdate={(prev, cur) => prev?.envia?.entregaSucursal?.activada !== cur?.envia?.entregaSucursal?.activada}>
                  {({ getFieldValue }) => {
                    const sucursalActivada = !!getFieldValue(["envia", "entregaSucursal", "activada"]);
                    return (
                      <FormItem
                        label="Desactivar envío a domicilio"
                        name={["envia", "desactivarEnvioDomicilio"]}
                        margin
                        valuePropName="checked"
                        tooltip="Si se activa, el checkout de la tienda solo permitirá recoger en sucursal (se oculta la opción de envío a domicilio). Requiere que 'Permitir entrega en sucursal' esté activado."
                      >
                        <Switch disabled={!sucursalActivada} />
                      </FormItem>
                    );
                  }}
                </Form.Item>
                <Row gutter={8}>
                  <Col span={12}>
                    <FormItem label="Etiqueta del método (checkout)" name={["envia", "entregaSucursal", "etiquetaMetodo"]} margin tooltip="Texto del botón en el checkout.">
                      <Input placeholder="Ej. Recoger en punto aliado" maxLength={60} />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem label="Título de la sección" name={["envia", "entregaSucursal", "tituloSeccion"]} margin tooltip="Encabezado que se muestra arriba del listado de sucursales.">
                      <Input placeholder="Ej. Elige tu punto de recolección" maxLength={80} />
                    </FormItem>
                  </Col>
                </Row>
                <FormItem label="Descripción visible al cliente" name={["envia", "entregaSucursal", "descripcionCheckout"]} margin tooltip="Texto explicativo que verá el cliente al elegir esta opción.">
                  <Input.TextArea rows={2} maxLength={240} showCount placeholder="Ej. Recoge tu pedido en nuestros puntos aliados, sin costo de envío." />
                </FormItem>
                {this.state.previewSucursal?.activada && (
                  <div style={{ border: "1px dashed #91caff", borderRadius: 8, padding: 14, marginBottom: 16, background: "#f0f5ff" }}>
                    <div style={{ fontSize: 11, color: "#8c8c8c", marginBottom: 8, textTransform: "uppercase", letterSpacing: 1 }}>Vista previa (checkout del alumno)</div>
                    <div style={{ border: `2px solid #1677ff`, borderRadius: 8, padding: "10px 14px", display: "flex", gap: 10, alignItems: "flex-start", background: "#fff" }}>
                      <span style={{ width: 14, height: 14, borderRadius: "50%", background: "#1677ff", display: "inline-block", marginTop: 3, flexShrink: 0 }} />
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 14, color: this.state.previewSucursal.etiquetaMetodo?.trim() ? "#1a1a1a" : "#ff4d4f" }}>
                          {this.state.previewSucursal.etiquetaMetodo?.trim() || "(sin etiqueta del método)"}
                        </div>
                        <div style={{ fontSize: 12, color: this.state.previewSucursal.descripcionCheckout?.trim() ? "#595959" : "#ff4d4f", marginTop: 2 }}>
                          {this.state.previewSucursal.descripcionCheckout?.trim() || "(sin descripción)"}
                        </div>
                      </div>
                    </div>
                    {(this.state.previewSucursal.direcciones?.length > 0) && (
                      <div style={{ marginTop: 12 }}>
                        <div style={{ fontWeight: 600, fontSize: 13, color: this.state.previewSucursal.tituloSeccion?.trim() ? "#1a1a1a" : "#ff4d4f", marginBottom: 6 }}>
                          {this.state.previewSucursal.tituloSeccion?.trim() || "(sin título de sección)"}
                        </div>
                        {this.state.previewSucursal.direcciones.map((d, i) => (
                          <div key={i} style={{ border: "1px solid #d9d9d9", borderRadius: 6, padding: "8px 12px", marginTop: 4, background: "#fff" }}>
                            <div style={{ fontWeight: 600, fontSize: 13, color: d?.etiqueta?.trim() ? "#1a1a1a" : "#ff4d4f" }}>
                              {d?.etiqueta?.trim() || `(sin nombre — Sucursal ${i + 1})`}
                            </div>
                            {d?.calle && (
                              <div style={{ fontSize: 12, color: "#8c8c8c", marginTop: 2 }}>
                                {[d.calle, d.numeroCalle, d.colonia, d.municipio, d.estado].filter(Boolean).join(", ")}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                <Form.List name={["envia", "entregaSucursal", "direcciones"]}>
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, idx) => (
                        <Card
                          key={key}
                          size="small"
                          title={`Sucursal ${idx + 1}`}
                          style={{ marginBottom: 12, background: "#fafafa", borderColor: "#e8e8e8" }}
                          extra={
                            <ButtonItem type="default" danger size="small" icon={<MinusOutlined />} onClick={() => {
                              remove(name);
                              this.setState((prev) => {
                                const copy = (obj) => { const next = { ...obj }; delete next[idx]; return next; };
                                return { objetoMunicipiosSucursales: copy(prev.objetoMunicipiosSucursales), objetoColoniasSucursales: copy(prev.objetoColoniasSucursales), todasColoniasSucursales: copy(prev.todasColoniasSucursales) };
                              });
                            }} />
                          }
                        >
                          <FormItem {...restField} label="Etiqueta" name={[name, "etiqueta"]} margin tooltip="Nombre de la sucursal visible en el checkout." required>
                            <InputItem placeholder="Ej. Sucursal Centro" />
                          </FormItem>
                          <Row gutter={8}>
                            <Col span={12}>
                              <FormItem {...restField} label="Código Postal" name={[name, "coloniaId"]} margin>
                                <SelectItem showSearch onSearch={(value) => this.onSearchColoniaSucursal(idx, value)} onSelect={(value) => this.onSelectColoniaIdSucursal(idx, value)} placeholder="CP">
                                  {this.state.objetoColoniasSucursales[idx] || <Option disabled>Busque CP</Option>}
                                </SelectItem>
                              </FormItem>
                            </Col>
                            <Col span={12}>
                              <FormItem {...restField} label="Colonia" name={[name, "colonia"]} margin pattern>
                                <InputItem placeholder="Colonia" />
                              </FormItem>
                            </Col>
                          </Row>
                          <Row gutter={8}>
                            <Col span={12}><FormItem {...restField} label="Calle" name={[name, "calle"]} margin><InputItem /></FormItem></Col>
                            <Col span={6}><FormItem {...restField} label="Núm. Ext" name={[name, "numeroCalle"]} margin><InputItem numeroCalle /></FormItem></Col>
                            <Col span={6}><FormItem {...restField} label="Núm. Int" name={[name, "numeroInterior"]} margin><InputItem /></FormItem></Col>
                          </Row>
                          <Row gutter={8}>
                            <Col span={12}>
                              <FormItem {...restField} label="Municipio" name={[name, "municipioId"]} margin>
                                <SelectItem onChange={(value) => this.onChangeMunicipioSucursal(idx, value)} placeholder="Municipio">
                                  {this.state.objetoMunicipiosSucursales[idx]}
                                </SelectItem>
                              </FormItem>
                            </Col>
                            <Col span={12}>
                              <FormItem {...restField} label="Estado" name={[name, "estadoId"]} margin>
                                <SelectItem onChange={(value) => this.onChangeEstadoSucursal(idx, value)} placeholder="Estado">
                                  {this.state.todasEstados.map((v) => <Option key={v._id} value={v._id}>{v.nombre}</Option>)}
                                </SelectItem>
                              </FormItem>
                            </Col>
                          </Row>
                          <FormItem {...restField} label="País" name={[name, "paisId"]} margin>
                            <SelectItem placeholder="País">{this.state.todasPaises.map((v) => <Option key={v._id} value={v._id}>{v.nombre}</Option>)}</SelectItem>
                          </FormItem>
                          <Row gutter={8}>
                            <Col span={12}><FormItem {...restField} label="Correo" name={[name, "correo"]} margin email><InputItem /></FormItem></Col>
                            <Col span={12}><FormItem {...restField} label="Teléfono" name={[name, "telefono"]} margin><InputNumberItem celular /></FormItem></Col>
                          </Row>
                        </Card>
                      ))}
                      <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />} disabled={fields.length >= 3}>
                        {fields.length >= 3 ? "Máximo 3 sucursales" : "Agregar sucursal"}
                      </ButtonItem>
                    </>
                  )}
                </Form.List>
              </DynamicCardForm>
            </Col>
          </Row>

          <div
            style={{
              pointerEvents: envioManualActivo ? "none" : "auto",
              opacity: envioManualActivo ? 0.5 : 1,
              transition: "opacity 0.3s",
            }}
          >
            <Row gutter={24}>
              <Col span={12}>
                <DynamicCardForm title="Envia.com (Conexión)">
                  <Row gutter={24}>
                    <Col span={24}>
                      <FormItem label="API Token Envia.com" name={["envia", "token"]} margin labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} style={{ marginBottom: 0 }}>
                        <Input.Password visibilityToggle={false} disabled={credencialesBloqueadas} prefix={<LockOutlined />} />
                      </FormItem>
                    </Col>
                  </Row>
                </DynamicCardForm>

                <DynamicCardForm title="Dirección de Bodega" collapsable defaultOpen>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Alert message="Dirección de Origen" description="Esta dirección aparecerá como el Remitente en tus guías de envío de bodega propia." type="info" showIcon style={{ marginBottom: 15 }} />
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={12}>
                      <FormItem label="Código Postal" name={["envia", "direccionBodega", "coloniaId"]} margin>
                        <SelectItem showSearch onSearch={this.onSearchColoniaBodega.bind(this)} onSelect={this.onSelectColoniaIdBodega.bind(this)} placeholder="CP">
                          {this.state.objetoColoniasBodega || <Option disabled>Busque CP</Option>}
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label="Colonia" name={["envia", "direccionBodega", "colonia"]} margin pattern>
                        <InputItem placeholder="Colonia" />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={12}>
                      <FormItem label="Calle" name={["envia", "direccionBodega", "calle"]} margin>
                        <InputItem />
                      </FormItem>
                    </Col>
                    <Col span={6}>
                      <FormItem label="Núm. Ext" name={["envia", "direccionBodega", "numeroCalle"]} margin>
                        <InputItem numeroCalle />
                      </FormItem>
                    </Col>
                    <Col span={6}>
                      <FormItem label="Núm. Int" name={["envia", "direccionBodega", "numeroInterior"]} margin>
                        <InputItem />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={12}>
                      <FormItem label="Municipio" name={["envia", "direccionBodega", "municipioId"]} margin>
                        <SelectItem onChange={(value) => this.onChangeMunicipioBodega(value, false)} placeholder="Municipio">
                          {this.state.objetoMunicipiosBodega}
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label="Estado" name={["envia", "direccionBodega", "estadoId"]} margin>
                        <SelectItem onChange={(value) => this.onChangeEstadoBodega(value, false)} placeholder="Estado">
                          {this.state.todasEstados.map((v) => <Option key={v._id} value={v._id}>{v.nombre}</Option>)}
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                  <FormItem label="País" name={["envia", "direccionBodega", "paisId"]} margin>
                    <SelectItem placeholder="País">
                      {this.state.todasPaises.map((v) => <Option key={v._id} value={v._id}>{v.nombre}</Option>)}
                    </SelectItem>
                  </FormItem>
                  <Row gutter={8}>
                    <Col span={12}>
                      <FormItem label="Correo Bodega" name={["envia", "direccionBodega", "correo"]} margin email>
                        <InputItem />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label="Teléfono Bodega" name={["envia", "direccionBodega", "telefono"]} margin>
                        <InputNumberItem celular />
                      </FormItem>
                    </Col>
                  </Row>
                </DynamicCardForm>
              </Col>

              <Col span={12}>
                <DynamicCardForm title="Opciones de Paquetería y Reglas de Cobro" collapsable defaultOpen={false}>
                  <Row gutter={8}>
                    <Col span={24}>
                      <Alert message="Selección de Transportistas" description="Puedes elegir un máximo de 3 paqueterías para cotizar los envíos en tu tienda en línea." type="info" showIcon style={{ marginBottom: 15 }} />
                      <Form.Item noStyle shouldUpdate={(prev, cur) => prev?.envia?.paqueteriasActivas !== cur?.envia?.paqueteriasActivas}>
                        {({ getFieldValue }) => {
                          const activas = getFieldValue(["envia", "paqueteriasActivas"]) || [];
                          return (
                            <>
                              <FormItem label="Paqueterías Disponibles con Envia.com" name={["envia", "paqueteriasActivas"]} margin rules={[{ type: "array", max: 3, message: "Solo puedes seleccionar hasta 3 paqueterías" }]}>
                                <Select mode="multiple" placeholder="Busca o selecciona las paqueterías" style={{ width: "100%" }} optionLabelProp="label" showSearch optionFilterProp="children" filterOption={(input, option) => (option?.value ?? "").toLowerCase().includes(input.toLowerCase())}>
                                  {this.state.catalogoPaqueterias.map((paq) => {
                                    const isDisabled = activas.length >= 3 && !activas.includes(paq.nombre);
                                    return (
                                      <Option key={paq._id} value={paq.nombre} label={paq.nombre.toUpperCase()} disabled={isDisabled}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                          {paq.logo && <img src={paq.logo} alt={paq.nombre} style={{ height: "20px", width: "auto", objectFit: "contain" }} />}
                                          <span style={{ textTransform: "capitalize" }}>{paq.nombre}</span>
                                        </div>
                                      </Option>
                                    );
                                  })}
                                </Select>
                              </FormItem>
                              {activas.length > 0 && (
                                <div style={{ marginTop: 20, display: "flex", flexDirection: "column", gap: "10px" }}>
                                  <p style={{ fontWeight: 500, margin: 0, color: "#595959" }}>Información de paqueterías seleccionadas:</p>
                                  {activas.map((nombreActiva) => {
                                    const infoPaq = this.state.catalogoPaqueterias.find((p) => p.nombre === nombreActiva);
                                    if (!infoPaq) return null;
                                    return (
                                      <Card size="small" key={infoPaq._id} style={{ borderColor: "#e8e8e8", background: "#fafafa" }}>
                                        <div style={{ display: "flex", alignItems: "flex-start", gap: "15px" }}>
                                          {infoPaq.logo && <img src={infoPaq.logo} alt={infoPaq.nombre} style={{ height: "80px", width: "80px", objectFit: "contain", padding: "4px", borderRadius: "4px" }} />}
                                          <div style={{ flex: 1 }}>
                                            <h4 style={{ margin: 0, textTransform: "capitalize", color: "#1890ff" }}>{infoPaq.nombre}</h4>
                                            <Row gutter={[16, 4]} style={{ marginTop: 8, fontSize: "12px" }}>
                                              <Col span={12}><span style={{ color: "#8c8c8c" }}>Límite Caja:</span> <strong>{infoPaq.limitePesoCaja > 0 ? `${infoPaq.limitePesoCaja} kg` : "Sin límite config."}</strong></Col>
                                              <Col span={12}><span style={{ color: "#8c8c8c" }}>Recolección Mismo Día:</span> <strong>{infoPaq.recoleccionMismoDia ? "Sí" : "No"}</strong></Col>
                                              <Col span={12}><span style={{ color: "#8c8c8c" }}>Horario Recolección:</span> <strong>{infoPaq.horaInicioRecoleccion && infoPaq.horaFinRecoleccion ? `${infoPaq.horaInicioRecoleccion}:00 a ${infoPaq.horaFinRecoleccion}:00` : "N/A"}</strong></Col>
                                              <Col span={12}><span style={{ color: "#8c8c8c" }}>URL Rastreo:</span> <a href={infoPaq.urlRastreo} target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", maxWidth: "120px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "bottom" }}>{infoPaq.urlRastreo || "N/A"}</a></Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Card>
                                    );
                                  })}
                                </div>
                              )}
                            </>
                          );
                        }}
                      </Form.Item>
                    </Col>
                  </Row>

                  <Divider>Reglas de Cobro al Cliente</Divider>
                  <Row gutter={8}>
                    <Col span={12}>
                      <FormItem label="Envío Gratis a partir de ($)" name={["envia", "reglasPrecios", "montoParaEnvioGratis"]} tooltip="Si el total supera este monto, el envío será gratis (0 para desactivar)." margin>
                        <InputNumberItem placeholder="Ej. 2000" style={{ width: "100%" }} />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label="Modo de cobro" name={["envia", "reglasPrecios", "modoCobro"]} margin>
                        <SelectItem style={{ width: "100%" }}>
                          <Option value="exacto">Costo exacto API</Option>
                          <Option value="porcentaje">Agregar Porcentaje (%)</Option>
                          <Option value="rangos">Por Rangos de Costo</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                  <Form.Item noStyle shouldUpdate={(prev, cur) => prev?.envia?.reglasPrecios?.modoCobro !== cur?.envia?.reglasPrecios?.modoCobro}>
                    {({ getFieldValue }) => {
                      const modoCobro = getFieldValue(["envia", "reglasPrecios", "modoCobro"]);
                      if (modoCobro === "porcentaje") {
                        return (
                          <FormItem label="Porcentaje Extra de Ganancia (%)" name={["envia", "reglasPrecios", "porcentajeExtra"]} margin tooltip="Ejemplo: Si la API cobra $100 y pones 5%, se le cobrará $105 al cliente.">
                            <InputNumberItem max={100} min={0} style={{ width: "100%" }} />
                          </FormItem>
                        );
                      }
                      if (modoCobro === "rangos") {
                        return (
                          <div style={{ backgroundColor: "#fafafa", padding: 10, borderRadius: 5 }}>
                            <p style={{ marginBottom: 10, fontWeight: "bold" }}>Definir Rangos</p>
                            <Form.List name={["envia", "reglasPrecios", "rangos"]}>
                              {(fields, { add, remove }) => (
                                <>
                                  {fields.map(({ key, name, ...restField }) => (
                                    <Row gutter={8} key={key} style={{ marginBottom: 10 }}>
                                      <Col span={7}><FormItem {...restField} name={[name, "costoApiMinimo"]} margin={false}><InputNumberItem readOnly dinero placeholder="Costo Min ($)" style={{ width: "100%" }} /></FormItem></Col>
                                      <Col span={7}><FormItem {...restField} name={[name, "costoApiMaximo"]} margin={false}><InputNumberItem dinero placeholder="Costo Max ($)" style={{ width: "100%" }} /></FormItem></Col>
                                      <Col span={7}><FormItem {...restField} name={[name, "precioCliente"]} margin={false}><InputNumberItem dinero placeholder="Cobrar ($)" style={{ width: "100%" }} /></FormItem></Col>
                                      <Col span={3} style={{ display: "flex", alignItems: "center" }}>
                                        <ButtonItem type="default" danger onClick={() => remove(name)} icon={<MinusOutlined />} block />
                                      </Col>
                                    </Row>
                                  ))}
                                  <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>Agregar Rango</ButtonItem>
                                </>
                              )}
                            </Form.List>
                          </div>
                        );
                      }
                      return null;
                    }}
                  </Form.Item>
                </DynamicCardForm>

                <DynamicCardForm title="Logística y Dropshipping" style={{ margin: "0 auto 12px auto", maxWidth: "98%" }}>
                  <Alert message="Proveedores Externos" description="Configura qué proveedor se encargará del surtido automático (Dropshipping)." type="warning" showIcon style={{ marginBottom: 15 }} />
                  <FormItem label="Proveedor URREA Activo" name={["logistica", "proveedorDropshippingId"]} margin>
                    <SelectItem showSearch placeholder="Busca por nombre o RFC" onSearch={this.buscarProveedoresDropshipping} onSelect={this.onSelectProveedorUrrea} filterOption={false}>
                      {this.state.proveedoresDropshipping.map((p) => (
                        <Option key={p._id} value={p._id}>{(p.razonSocial || p.nombre) + " - " + p.rfc}</Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                  {this.state.proveedorUrreaSeleccionado && (
                    <Card size="small" title="Información Detallada de Recolección (URREA)" style={{ backgroundColor: "#f0f2f5", marginTop: 10 }}>
                      <Descriptions column={1} size="small" bordered>
                        <Descriptions.Item label="Proveedor">
                          <b>{this.state.proveedorUrreaSeleccionado.razonSocial || this.state.proveedorUrreaSeleccionado.nombre}</b>
                        </Descriptions.Item>
                        <Descriptions.Item label="RFC">{this.state.proveedorUrreaSeleccionado.rfc}</Descriptions.Item>
                        <Descriptions.Item label="Dirección Completa">
                          {this.state.proveedorUrreaSeleccionado.direccionDropshipping ? (
                            <div>
                              <div>{this.state.proveedorUrreaSeleccionado.direccionDropshipping.calle} #{this.state.proveedorUrreaSeleccionado.direccionDropshipping.numeroCalle}{this.state.proveedorUrreaSeleccionado.direccionDropshipping.numeroInterior ? ` Int. ${this.state.proveedorUrreaSeleccionado.direccionDropshipping.numeroInterior}` : ""}</div>
                              <div>Col. {this.state.proveedorUrreaSeleccionado.direccionDropshipping.colonia || this.state.proveedorUrreaSeleccionado.direccionDropshipping.coloniaId?.nombre}</div>
                              <div>{this.state.proveedorUrreaSeleccionado.direccionDropshipping.municipioId?.nombre}, {this.state.proveedorUrreaSeleccionado.direccionDropshipping.estadoId?.nombre}</div>
                              <div>{this.state.proveedorUrreaSeleccionado.direccionDropshipping.paisId?.nombre || "México"}{this.state.proveedorUrreaSeleccionado.direccionDropshipping.coloniaId?.cp ? ` - CP: ${this.state.proveedorUrreaSeleccionado.direccionDropshipping.coloniaId.cp}` : ""}</div>
                            </div>
                          ) : (
                            <span style={{ color: "red" }}>Sin dirección configurada</span>
                          )}
                        </Descriptions.Item>
                        <Descriptions.Item label="Contacto URREA">
                          {this.state.proveedorUrreaSeleccionado.direccionDropshipping?.correo && <div>Email: {this.state.proveedorUrreaSeleccionado.direccionDropshipping.correo}</div>}
                          {this.state.proveedorUrreaSeleccionado.direccionDropshipping?.telefono && <div>Tel: {this.state.proveedorUrreaSeleccionado.direccionDropshipping.telefono}</div>}
                        </Descriptions.Item>
                      </Descriptions>
                    </Card>
                  )}
                </DynamicCardForm>
              </Col>
            </Row>
          </div>

          <Divider style={{ margin: "20px 0" }} />
          <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
            {escuelaSeleccionadaId
              ? configEscuelaExiste
                ? `Guardar config. de "${nombreEscuelaActual}"`
                : `Crear config. propia para "${nombreEscuelaActual}"`
              : "Guardar Configuración"}
          </ButtonItem>
        </Form>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  escuela: state.empresa.escuela,
  permisoAnadirModificarTokens:
    state.user.tipo === 0 ||
    state.user.permisos.find((v) => v.permisoId.toString() === "6a1db0a98958639144fd5f0e")?.activado,
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(EnviosConfiguracion);
